import serviceAgreement from './serviceAgreement'

export default [{
    path: '/agreement/service',
    name:'serviceAgreement',
    component: serviceAgreement
}]
